import { useState } from "react";
import { Form, FormActions, FormInput } from "../Controls/Form";
import CmModal from "../Controls/CmModal";
import API from "@src/API";
import { toast } from "react-toastify";

export default function EmployerManagementLocator(props) {
  const [showOpenManagement, updateShowOpenManagement] = useState(false);
  const [representative, updateRepresentative] = useState({});

  function onShowOpenManagement() {
    updateRepresentative({});
    updateShowOpenManagement(true);
  }

  function onCancelForm() {
    updateShowOpenManagement(false);
  }

  async function onAcceptAsync() {
    const email = (representative.email || representative.Email || "").trim();
    if (!email) {
      toast.error("Email is required");
      return;
    }

    const payload = {
      ...representative,
      employerId: props.employerId,
      firstName: representative.firstName ?? representative.FirstName,
      lastName: representative.lastName ?? representative.LastName,
      email,
    };

    const resp = await API.postAsync("/Person", payload);
    if (!resp || !resp.ok) {
      const msg =
        resp?.jsonData?.error ||
        resp?.jsonData?.message ||
        "There was an error submitting your recommendation. Please try again later.";
      toast.error(msg);
      return;
    }

    const action = (resp.jsonData?.action || resp.jsonData?.Action || "").toLowerCase();
    if (action === "invited") {
      toast.success(
        "Invite queued. We'll email them to create an account and help shape this company's profile."
      );
    } else if (action === "associated") {
      toast.success(
        resp.jsonData?.alreadyAssociated || resp.jsonData?.AlreadyAssociated
          ? "That person is already associated with this company."
          : "That person is now associated with this company."
      );
    } else {
      toast.success("Thank you for your recommendation!");
    }
    updateShowOpenManagement(false);
    props.onAssociated?.();
  }

  return (
    <div className="pagebody employerManagementLocator">
      <p>
        <span className="header">Open Management: </span>
        This employer has not designated a managing representative. Please help us in filling out
        any info you may know about this organization.{" "}
      </p>
      <p>
        If you could{" "}
        <span className="helpLink" onClick={onShowOpenManagement}>
          recomend
        </span>{" "}
        a potential representative it would be greatly appreciated.
      </p>

      <CmModal
        open={showOpenManagement}
        bare
        onClose={onCancelForm}
        title="Recommended Representative"
        size="form"
        testId="recommended-representative-modal"
      >
        <div className="cm-modal-embedded">
          <Form
            className="cm-modal-form"
            object={representative}
            onUpdate={updateRepresentative}
            onSubmitAsync={onAcceptAsync}
            onCancelAsync={async () => {
              onCancelForm();
            }}
          >
            <FormInput type="text" field="firstName" placeholder="First Name" />
            <FormInput type="text" field="lastName" placeholder="Last Name" />
            <FormInput type="email" field="email" placeholder="Email" />
            <FormActions doneLabel="Accept" />
          </Form>
        </div>
      </CmModal>
    </div>
  );
}
